import { useEffect } from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';
import { Link } from 'react-router-dom';

import { connect } from 'react-redux';
import Button from '@mui/material/Button';
import Side from '../partials/SideBar';
import Header from './Header';
import renderAssessments from './renderAssessments';
import { fetchAppointment } from '../../../actions/sessions';
import { THERAPY_URL } from '../../../environment';

function PostSessionAssessment({
  fetchAppointment: fetchAppointmentAction,
  match,
  postAssessment = [],
}) {
  useEffect(() => {
    fetchAppointmentAction(match.params.id);
    // Match class componentDidMount: run once on mount only.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="row no-gutters" style={{ height: '100%' }}>
      <div className="col-2">
        <Side color="#e6f9f7" />
      </div>
      <div
        className="col-10"
        style={{ paddingTop: '40px', paddingLeft: '30px' }}
      >
        <Header />
        <div style={{ maxWidth: '700px' }}>
          {renderAssessments(postAssessment)}
          <Link to="/dashboard">
            <Button
              className="flat-button-green "
            >complete session</Button>
          </Link>
        </div>
      </div>
    </div>
  );
}

PostSessionAssessment.propTypes = {
  fetchAppointment: PropTypes.func.isRequired,
  match: PropTypes.object.isRequired,
  postAssessment: PropTypes.array,
};

function mapStateToProps(state) {
  return {
    appointment: _.get(state, 'session.appointment'),
    postAssessment: _.get(state, 'session.appointment.post_assessment'),
  };
}

export default connect(mapStateToProps, {
  fetchAppointment,
})(PostSessionAssessment);
